import { useState } from 'react';
import userApi from '../../../../services/apiServices/userApi';
import { toast } from 'react-toastify';

const UpdatePasswordModal = ({ isOpen, onClose }) => {
    const [password, setPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [loading, setLoading] = useState(false);

    if (!isOpen) return null;

    const handleSubmit = async () => {
        try {
            setLoading(true);
            await userApi.updatePassword({ password, newPassword });
            toast.success('Senha atualizada com sucesso!');
            onClose();
        } catch (error) {
            toast.error('Erro ao atualizar senha.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="loading-backdrop">
            <div className="loading-modal">
                <h3>Alterar Senha</h3>

                <input
                    type="password"
                    className="main-input margin-top-default"
                    placeholder="Senha Atual"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                />
                <input
                    type="password"
                    className="main-input margin-top-default"
                    placeholder="Nova Senha"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                />

                <button
                    className="main-button margin-top-default"
                    onClick={handleSubmit}
                    disabled={loading}
                >
                    {loading ? 'Salvando...' : 'Salvar'}
                </button>

                <button
                    className="main-button margin-top-default"
                    onClick={onClose}
                    disabled={loading}
                >
                    Cancelar
                </button>
            </div>
        </div>
    );
};

export default UpdatePasswordModal;
